<div *ngIf="buttonMode">
    <button class="containerSideButton" type="button" (click)="onExit()">Exit</button>
</div>
<div #container class="containerSide" *ngIf="!buttonMode">
   <mat-icon *ngIf="extensionActive" style="color: green" #extension class="server">health_and_safety</mat-icon>
    <mat-icon *ngIf="!isConnected" style="color: red" [hidden]="isRegistered" #server class="server taskPadRight">link_off</mat-icon>
    <mat-icon *ngIf="isConnected && !isRegistered" style="color: yellow" [hidden]="isRegistered" #server class="server taskPadRight">refresh</mat-icon>
    <mat-icon *ngIf="isConnected && isRegistered" style="color: green" [hidden]="isRegistered" #server class="server taskPadRight">add_link</mat-icon>
    <button #play [disabled]="!isRegistered || isPlaying" mat-raised-button class="containerSideButton" type="button" (click)="onToolbarPlay()">
        <mat-icon class="fontSizeIcon">play_circle_outline</mat-icon>
    </button>
    <button #stop [disabled]="!isRegistered || !isPlaying" #close mat-raised-button class="containerSideButton" type="button" (click)="onToolbarStop()">
        <mat-icon class="fontSizeIcon">stop_circle</mat-icon>
    </button>
    <button mat-raised-button class="containerSideButton" type="button" (click)="onInfo()">
        <mat-icon class="fontSizeIcon">settings</mat-icon>
    </button>
    <button *ngIf="isFullScreen" mat-raised-button class="containerSideButton" type="button" (click)="onToggleFull()">
        <mat-icon class="fontSizeIcon">fullscreen</mat-icon>
    </button>
    <button *ngIf="!isFullScreen" mat-raised-button class="containerSideButton" type="button" (click)="onToggleFull()">
        <mat-icon class="fontSizeIcon">fullscreen_exit</mat-icon>
    </button>
    <button #close mat-raised-button class="containerSideButton" type="button" (click)="onExit()">
      <mat-icon class="fontSizeIcon">highlight_off</mat-icon>
    </button>
</div>
